import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import { BIDDERS_CRUD_ACTION_CREATORS } from '../../actions/bidders_actions';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import ProposalForm from '../proposal_form/ProposalForm';
import { withUserType } from '../withUserType';
import { compareStrings, nullSafeGet } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { isInternalTech } from '../../utils/AuthUtils';
import {
	requestsForProposalRestCrudThunksForBuyer,
	requestsForProposalRestCrudThunksForSupplier,
} from '../../thunks/requests_for_proposal_thunks';
import {
	biddersRestCrudThunksForBuyer,
	biddersRestCrudThunksForSupplier,
} from '../../thunks/bidders_thunks';

const queryString = require('qs');
const { Content } = Layout;

class NewProposalPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
	}
	render() {
		const { location, match, history, userType, currentUser, getRequestForProposal, getBidders } =
			this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const workOrderId = queryParams.workOrderId;
		const supplierFacilityId = queryParams.supplierFacilityId;
		const requestForProposalId = match.params.id;
		const formData = {
			supplierFacilityId: supplierFacilityId,
			workOrderId: workOrderId,
			requestForProposalId: requestForProposalId,
		};

		const isBuyerOrInternalTech = userType === ROLE_TYPES.BUYER || isInternalTech(currentUser);
		return (
			<Content>
				<LogOnMountWithStandardEventProperties eventType="visited new proposal page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card>
							<div>
								<ProposalForm
									formData={formData}
									onSuccess={(rec) => {
										Promise.all([
											getBidders({ requestForProposalId }, 'RFP_DETAIL_BIDDERS'),
											getRequestForProposal(requestForProposalId),
										]);
										history.push(
											`/${userType}/${
												isBuyerOrInternalTech ? 'requestsForProposal' : 'opportunities'
											}/detail/${rec.requestForProposal.id}/${
												isBuyerOrInternalTech ? 'compareBids' : 'details'
											}`
										);
									}}
								/>
							</div>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	biddersFormData: state.bidders.formData,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	saveFormData: (formData) => dispatch(BIDDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	getRequestForProposal: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? requestsForProposalRestCrudThunksForSupplier.readOne(id)
				: requestsForProposalRestCrudThunksForBuyer.readOne(id)
		),
	getBidders: (params, targetCollectionName, pagination, sorting, filters) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? biddersRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: biddersRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(NewProposalPage))
);
